import {interval as observableInterval, Subscription} from 'rxjs';
import {filter, bufferCount, map} from 'rxjs/operators';
import {Component, OnInit, AfterViewInit, Inject, Renderer2, Input, OnDestroy, ElementRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoginService} from './login.service';
import {LotteriesService} from '../../lotteries.service';
import {countries} from '../../dashboard/account-details/countries';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Event} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import * as globals from '../../settings';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Location} from '@angular/common';
import {CookieService} from 'ngx-cookie-service';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {ActionService} from '../../_services/action.service';
import {GetDeviceService} from '../../_services/get-device.service';
import {ParamsService} from '../../_services/params.service';
import {CartService} from '../../_services/cart.service';
import {TimeService} from '../../_services/time.service';
import {LanguageService} from '../../_services/language.service';
import {UserService} from '../../_services/user.service';
import {IncomingdrawsService} from '../../_services/incomingdraws.service';
import {JsontranslateService} from '../../_services/jsontranslate.service';
import {CurrencyService} from '../../_services/currency.service';
import {c} from 'tar';
import {GetPaymentMethodsService} from '../paymentMethod/get-payment-methods.service';
import {EventManager} from '@angular/platform-browser';
import {JackpotConfigService} from '../../_services/jackpotConfig.service';
import {PaystackSupportService} from '../paystack-support.service';
import {PlatformLocation} from '@angular/common';


@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss', './navigation.mobile.component.scss']
})


export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('leftSide') leftSide: ElementRef;
    @ViewChild('rightSide') rightSide: ElementRef;
    loginForm: FormGroup;
    recallForm: FormGroup;
    email: string;
    title: any;
    password: string;
    showLogin: any;
    showLogin_tmp: any;
    showForgetPassword: any;
    userData: any;
    modalSize: any;
    step: any;
    countrySelect: any;
    showRecall: any;
    userTitle: any;
    showRegister: any;
    selectedValue: any;
    isNeeded: any;
    language: string;
    years: any;
    days: any;
    months: any;
    acceptTerms: any;
    cart: any;
    fromCart: any;
    isMobile: any;
    terms: any;
    resetPassword: any;
    resetSuccess: any;
    resetLinkSend: any;
    error73: boolean;
    error12: boolean;
    error69: boolean;
    error70: boolean;
    error45: boolean;
    error25: boolean;
    errorDefault: boolean;
    error48: boolean;
    error1010: boolean;
    errorVar: any;
    successMessage: boolean;
    isCart: boolean;
    devMode: boolean;
    langChange: boolean;
    @Input() loggedIn: any;
    error74: boolean;
    cartItems: any;
    resetToken: string;
    resetEmail: string;
    toSendEmail: string;
    showRestricted: boolean;
    prevent: boolean;
    wasClicked: boolean;
    loginValid: boolean;
    timeZone: string;
    virtualLogin: string;
    subscription: Subscription;
    loginSubscription: Subscription;
    logoutSubscription: Subscription;
    showLoginSubscription: Subscription;
    showLoginSubscription_tmp: Subscription;
    userDataSubscription: Subscription;
    registerSubscription: Subscription;
    showWinnerConfetti: Subscription;
    userBalanceSubscription: Subscription;
    userDataNameWithGenderSubscription: Subscription;
    loggedInSubscription: Subscription;
    resetTokenSubscription: Subscription;
    resetEmailSubscription: Subscription;
    resetPasswordSubscription: Subscription;
    showForgetPasswordSubscription: Subscription;
    modalSizeSubscription: Subscription;
    gameEntriesStatus: Subscription;
    scratchcardCheckoutStatus: Subscription;
    myScratch: Subscription;
    gameStatus: Subscription;
    startInstant: Subscription;
    toggleScratchContent: Subscription;
    error74Subscription: Subscription;
    errorDefaultSubscription: Subscription;
    languageSubscription: Subscription;
    incomingDrawsSubscription: Subscription;
    triggerDepositFromLink: Subscription;
    showRestrictedSubscription: Subscription;
    changedCurrency: Subscription;
    nameMagicSubscription: Subscription;
    customErrorMessageOnModalVisibleSubscription: Subscription;
    maxLengthEmail: string;
    device: any;
    canGoOn: any;
    sessionExpired: boolean;
    userBalance: any;
    tbpulse: string;
    userDataNameWithGender: any;
    isLoadingButton: boolean;
    languageParams: any;
    gameURL: string;
    frameWidth: number;
    frameHeight: number;
    openedGame: any;
    user: any;
    isLoadingButtonSub: any;
    showGameModal: any;
    checkForModal: any;
    hideMenu: boolean;
    lotteriesService: any;
    closeGame: any;
    runCheckout: boolean;
    checkoutId: any;
    checkoutTickets: any;
    scrCheckCnt: number;
    gameCloseTriggered: boolean;
    isUser: boolean;
    checkIfListened: boolean;
    ticketAmount: any;
    packageId: any;
    packageIdTmp: any;
    amountArray: any[];
    ifGameError: boolean;
    error000: boolean;
    error102: boolean;
    toggleContent: boolean;
    showIframe: string;
    openUserNeedIncreseBalance: boolean;
    confettiGo: string;
    isShowCart: boolean;
    notHideNavOnLoad: boolean;
    loginBanned: boolean;
    registerBanned: boolean;
    showRestrictedLoginRegister: boolean;
    currency: any;
    userMenuTooltip: boolean;
    powerballBundle: any;
    eurojackpotBundle: any;
    winnersBundle: any;
    winaijaLottoBundle: any;
    isLoadingButtonName: any;
    routerForNavbar: any;
    sortValues: any;
    selected_method_show_name: any;
    languageSwitcherReadyToShow: boolean;
    getPaymentMethodsSub: Subscription;
    gpmData: any;
    serverBannerMessage = globals.serverBannerMessage;
    banned: boolean;
    @ViewChild('restrictBanner', {read: ElementRef}) restrictionBanner: ElementRef;
    hiddenLastNameAt: any;
    hiddenFirstNameAt: any;
    navState: any;
    navStateOryginal: any;
    brand = globals.brand;
    afterComma = globals.afterComma;
    paystackFlow: boolean;
    customErrorMessageOnModalVisible: boolean;
    customErrorMessageOnModalMessage: any;
    hasFreeSpins: boolean;
    constructor
    (private router: Router,
     private translate: TranslateService,
     private fb: FormBuilder,
     private loginService: LoginService,
     private renderer: Renderer2,
     private activatedRoute: ActivatedRoute,
     private location: Location,
     private cookieService: CookieService,
     private actionService: ActionService,
     public lotteryService: LotteriesService,
     private jsontranslate: JsontranslateService,
     public subscriptionsService: SubscriptionsService,
     private deviceService: DeviceDetectorService,
     private getDeviceService: GetDeviceService,
     private paramsService: ParamsService,
     private cartService: CartService,
     private timeService: TimeService,
     private languageService: LanguageService,
     public userService: UserService,
     public incomingDraws: IncomingdrawsService,
     public currencyService: CurrencyService,
     public eventManager: EventManager,
     public getpmService: GetPaymentMethodsService,
     public jackpotConfig: JackpotConfigService,
     public paystackSupport: PaystackSupportService,
     public platformLocation: PlatformLocation) {
        platformLocation.onPopState(() => {
            this.renderer.removeClass(document.body, 'modal-open-game');
        });


        // const ua = navigator.userAgent.toLowerCase();
        // if (ua.indexOf('ipad') !== -1 || ua.indexOf('iphone') !== -1 || ua.indexOf('ipod') !== -1) {
        //     this.renderer.addClass(document.body, 'itsiphone');
        /* @todo: this is it: https://www.bram.us/2016/05/02/prevent-overscroll-bounce-in-ios-mobilesafari-pure-css/
        but performance is very bad */
        // }
        this.customErrorMessageOnModalVisible = false;
        this.powerballBundle = [];
        this.eurojackpotBundle = [];
        this.winnersBundle = [];
        this.winaijaLottoBundle = [];
        this.languageSwitcherReadyToShow = false;
        setTimeout(() => {
            this.notHideNavOnLoad = true;
        }, 1500);
        this.userMenuTooltip = false;
        const country = localStorage.getItem('country');
        if (country !== undefined) {
            this.lotteryService.getLotteries(globals.appDomain + '/user/getUserCountryByIp/getUserCountryByIp_nav.json')
                .subscribe(
                    result => {
                        if (result.message.countryCode === 'Banned') {
                            if (this.router.url !== '/not-allowed') {
                                this.banned = true;
                                this.router.navigate(['not-allowed']);
                            }
                            this.modalSize = 'modal-md';
                            this.showRestricted = !this.showRestricted;
                            this.prevent = true;
                            setInterval(() => {
                                if (this.restrictionBanner.nativeElement.classList.contains('open')) {
                                    return true;
                                } else {
                                    this.restrictionBanner.nativeElement.classList += 'open';
                                }
                            }, 500);
                        } else {
                            this.loginBanned = false;
                            this.registerBanned = false;
                            if (result.message.banType) {
                                if (result.message.banType === 'login') {
                                    this.loginBanned = true;
                                }
                                if (result.message.banType === 'register') {
                                    this.registerBanned = true;
                                }
                            }
                            this.subscriptionsService.setIsLoginBanned(this.loginBanned);
                            this.subscriptionsService.setIsRegisterBanned(this.registerBanned);
                            localStorage.setItem('country', result.message.countryCode);
                            if (localStorage.getItem('developerCurrencyCountryCode')) {
                                this.subscriptionsService.updateCountryCode(localStorage.getItem('developerCurrencyCountryCode'));
                                console.error('Your currency country code was changed to: ' +
                                    localStorage.getItem('developerCurrencyCountryCode') + '.\nIf You want to back to normal ' +
                                    'currency country code, please remove "developerCurrencyCountryCode" key from LocalStorage or do ' +
                                    'hard refresh in Your browser.\nIf You found a bug when using this feature, please add this ' +
                                    'information to the task.');
                            } else {
                                const currencyCountryCode = result.message.currencyCountry.toLowerCase();
                                if (currencyCountryCode) {
                                    this.subscriptionsService.updateCountryCode(currencyCountryCode);
                                    this.languageService.makeLanguagesGreatAgain('countryOnly', currencyCountryCode);
                                } else {
                                    this.subscriptionsService.updateCountryCode('en');
                                    this.languageService.makeLanguagesGreatAgain('countryOnly', 'en');
                                }
                            }

                            let checkCurrency;
                            checkCurrency = localStorage.getItem('currency');
                            if (!checkCurrency && result && result.status === 200 && result.message && result.message.defaultCurrency) {
                                this.subscriptionsService.emitChangeCurrency(result.message.defaultCurrency);
                            } else if (checkCurrency) {
                                this.subscriptionsService.emitChangeCurrency(JSON.parse(checkCurrency));
                            }
                        }
                    }
                );
        }
        this.showRestrictedSubscription = this.subscriptionsService.getIsRestrictedLoginRegister().subscribe(data => {
            if (data) {
                this.showRestrictedLoginRegister = data;
            }
        });
        this.languageSubscription = this.subscriptionsService.getLanguage().subscribe(data => {
            const x = {
                selectedValue: data
            };
            this.switchLanguage(x);

        });


        this.activatedRoute.queryParams.subscribe(params => {
            const thisInthis = this;
            const userExist = localStorage.getItem('playerDetails');
            if (params && params['cur'] && !userExist) {
                this.lotteryService.postData(globals.appDomain +
                    '/payments/getAvailableCurrencies/paymentsGetAvailableCurrencies_navigation.json',
                    '')
                    .subscribe(
                        response => {
                            if (response && response.status === 200 && response.message) {
                                response.message.forEach(function (value) {
                                    if (value && value.Code && value.Code === params['cur']) {
                                        thisInthis.subscriptionsService.emitChangeCurrency(value);
                                    }
                                });
                            }
                        }
                    );
            }
        });

        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                localStorage.setItem('currency', JSON.stringify(currency));
                this.currency = currency;
            }
        });

        this.triggerDepositFromLink = this.subscriptionsService.getDeposit().subscribe(data => {
            this.triggerDeposit();
        });
        this.userBalance = '0.00';
        this.toggleScratchContent = this.subscriptionsService.getToggleContent().subscribe(data => {
            if (this.lotteryService.isMobile) {
                if (this.toggleContent !== data) {
                    this.toggleContent = data;
                }
            }
        });
        this.openUserNeedIncreseBalance = false;
        this.runCheckout = false;
        this.scrCheckCnt = 0;
        this.sessionExpired = false;
        this.loginValid = false;
        this.errorVar = '';
        this.subscription = this.subscriptionsService.getCartItems().subscribe(cartLength => {
            this.cartItems = cartLength;
        });

        this.logoutSubscription = this.subscriptionsService.getLogout().subscribe(logout => {
            if (logout === true) {
                this.logOut(undefined);
                this.userData = undefined;
                this.renderer.removeClass(document.body, 'suspInfoOpened');
                this.renderer.removeClass(document.body, 'freeSpins');
            }
        });

        this.showLoginSubscription = this.subscriptionsService.getShowLogin().subscribe(showLogin => {
            this.showLogin = showLogin;
        });

        this.showLoginSubscription_tmp = this.subscriptionsService.getShowLogin_tmp().subscribe(showLogin_tmp => {
            this.showLogin_tmp = showLogin_tmp;
        });

        this.userDataSubscription = this.subscriptionsService.getUserData().subscribe(userData => {
            this.userData = userData;
        });

        this.error74Subscription = this.subscriptionsService.getError74().subscribe(error74 => {
            this.error74 = error74;
        });

        this.errorDefaultSubscription = this.subscriptionsService.getErrorDefault().subscribe(errorDefault => {
            this.errorDefault = errorDefault;
        });

        this.loginSubscription = this.subscriptionsService.getLogin().subscribe(login => {
            this.showLogin = login;
        });

        this.customErrorMessageOnModalVisibleSubscription = this.subscriptionsService.getOpenUniversalJinniErrorModal().subscribe(data => {
            if (data) {
                this.renderer.addClass(document.body, 'modal-open');
            }
            this.customErrorMessageOnModalVisible = data;

        });
        this.registerSubscription = this.subscriptionsService.getRegister().subscribe(register => {
            if (register === true) {
                if (this.registerBanned) {
                    this.modalSize = 'modal-md';
                    this.showRestrictedLoginRegister = true;
                } else {
                    this.showRegister = register;
                }
            } else {
                setTimeout(() => {
                    this.showRegister = register;
                }, 1000);
            }
        });

        this.subscriptionsService.getRegisterOrLogin().subscribe(registerOrLogin => {
            if (registerOrLogin) {
                this.renderer.addClass(document.body, 'modal-open');
                const ku = localStorage.getItem('knownUser');
                if (ku) {
                    this.subscriptionsService.emitLogin(true);
                    this.subscriptionsService.emitRegister(false);
                } else {
                    this.subscriptionsService.emitRegister(true);
                    this.subscriptionsService.emitLogin(false);
                }
            } else {
                this.subscriptionsService.emitLogin(false);
                this.subscriptionsService.emitRegister(false);
            }
        });

        this.showWinnerConfetti = this.subscriptionsService.getWinnerConfetti().subscribe(data => {
            this.confettiGo = 'go';
            setTimeout(() => {
                this.confettiGo = 'confetti_done';
            }, 6500);
        });
        this.cartService.updateCartLength();
        this.wasClicked = false;
        this.isNeeded = true;
        const DataString = localStorage.getItem('playerDetails');
        const DataJson = JSON.parse(DataString);
        this.waitForCountry();
        if (DataString && DataJson && DataJson.Currency) {
            this.subscriptionsService.emitChangeCurrency(DataJson.Currency);
        }

        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd), map((event: any) => event.url),)
            .subscribe((event) => {
                this.routerForNavbar = this.router.url.substring(4).replace('/', ' ').replace('?', ' ').replace('#', ' ');
                this.isShowCart = this.router.url.indexOf('/cart') > -1;
                this.renderer.removeClass(document.body, 'modal-open');
                this.subscriptionsService.emitToggleContent(true);
                this.cartService.updateCartLength();
                if (event.includes('cart') && !this.lotteryService.isMobile && !event.includes('payment-success')) {
                    this.isNeeded = false;
                } else {
                    this.isNeeded = true;
                }

                if (event.includes('cart')) {
                    this.renderer.addClass(document.body, 'cart-open');
                } else {
                    this.renderer.removeClass(document.body, 'cart-open');
                }
                const isUtm = localStorage.getItem('utm');
                if (isUtm !== null) {
                    document.location.hash = isUtm;
                    setTimeout(() => {
                        localStorage.removeItem('utm');
                    }, 4000);
                }
            });

        this.router.events.pipe(bufferCount(8)).subscribe((e: any[]) => {
            const userDataString = localStorage.getItem('playerDetails');
            const userDataJson = JSON.parse(userDataString);
            const updateView = localStorage.getItem('update_data');
            if (userDataJson === null) {
                return false;
            } else if (userDataJson.MemberID === undefined) {
                this.loggedIn = false;
                this.router.navigate(['/']);
                this.showLogin = true;
                this.modalSize = 'modal-md';
            } else if (updateView !== null) {

                if (localStorage.getItem('virtualLogin')) {
                    this.virtualLogin = '&virtualLogin=' + localStorage.getItem('virtualLogin');
                }

                const sendData = {};
                sendData['sessionId'] = userDataJson.sessionId;
                const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
                if (cookieIncentiveCodeExists) {
                    sendData['cookieValue'] = this.cookieService.get('incentiveCode');
                    this.cookieService.delete('incentiveCode');
                }
                if (this.virtualLogin) {
                    sendData['virtualLogin'] = this.virtualLogin.split('=')[1];
                }
                this.loginService
                    .postData
                    (globals.appDomain + '/user/details/' + userDataJson.MemberID +
                        '/userDetails_nav_1.json', this.loginService.getFormUrlEncoded(sendData))
                    .subscribe(
                        data => {
                            this.showLogin = false;
                            this.userData = data.message;
                            this.userBalance = +this.userData.RealBalance + +this.userData.BonusBalance;
                            this.userDataNameWithGender = {
                                FirstName: this.userData.FirstName,
                                LastName: this.userData.LastName,
                                Gender: this.userData.Gender,
                            };
                            const loggedInUser = data.message;
                            loggedInUser.sessionId = userDataJson.sessionId;
                            loggedInUser.memberId = userDataJson.MemberID;
                            if (data.message.ErrorID) {
                                this.loggedIn = false;
                                localStorage.setItem('expiredSession', 'true');
                                localStorage.removeItem('playerDetails');
                            } else {
                                this.subscriptionsService.emitChangeCurrency(data.message.Currency);
                                localStorage.removeItem('update_data');
                            }
                        }
                    );
            }
        });
        observableInterval(6000 * 15).subscribe(x => {
            const userDataString = localStorage.getItem('playerDetails');
            const userDataJson = JSON.parse(userDataString);
            if (userDataJson) {
                if (userDataJson.MemberID === undefined) {
                    localStorage.removeItem('playerDetails');
                    localStorage.removeItem('cart');
                    localStorage.setItem('knownUser', 'true');
                    this.subscriptionsService.updateCart(0);
                    this.subscriptionsService.updateBalance(0);
                    this.subscriptionsService.emitIsLoggedIn(false);
                    localStorage.setItem('expiredSession', 'true');
                    this.showLogin = true;
                    this.sessionExpired = true;
                    this.modalSize = 'modal-md';
                    localStorage.removeItem('expiredSession');
                    this.subscriptionsService.updateLogout(true);
                }
            }
            if (userDataString !== null) {

                if (localStorage.getItem('virtualLogin')) {
                    this.virtualLogin = '&virtualLogin=' + localStorage.getItem('virtualLogin');
                }

                const sendData = {};
                sendData['sessionId'] = userDataJson.sessionId;
                const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
                if (cookieIncentiveCodeExists) {
                    sendData['cookieValue'] = this.cookieService.get('incentiveCode');
                    this.cookieService.delete('incentiveCode');
                }
                sendData['Fields'] = 'MemberID,RealBalance,BonusBalance,FirstName,LastName,Gender,Country,CountryCode,Status,HasFreeSpins';
                if (this.virtualLogin) {
                    sendData['virtualLogin'] = this.virtualLogin.split('=')[1];
                }
                this.loginService
                    .postData
                    (globals.appDomain + '/user/details/' + userDataJson.MemberID +
                        '/userDetails_nav_2.json', this.loginService.getFormUrlEncoded(sendData))
                    .subscribe(
                        data => {
                            this.showLogin = false;
                            if (data.apiErrorMessage || data.message.ErrorID) {
                                localStorage.removeItem('playerDetails');
                                localStorage.setItem('expiredSession', 'true');
                                this.renderer.removeClass(document.body, 'modal-open-game');
                                this.renderer.addClass(document.body, 'modal-open');
                                this.loggedIn = false;
                                this.subscriptionsService.updateCart(0);
                                this.subscriptionsService.updateBalance(0);
                                this.subscriptionsService.emitIsLoggedIn(false);
                                if (this.router.url.toString().includes('/dashboard') || this.router.url.toString().includes('/cart')) {
                                    this.router.navigate(['/']);
                                }
                                this.showLogin = true;
                                this.sessionExpired = true;
                                this.modalSize = 'modal-md';
                                localStorage.removeItem('expiredSession');
                                this.subscriptionsService.updateLogout(true);
                            } else {
                                this.userData = data.message;
                                this.userBalance = +this.userData.RealBalance + +this.userData.BonusBalance;
                                this.userDataNameWithGender = {
                                    FirstName: this.userData.FirstName,
                                    LastName: this.userData.LastName,
                                    Gender: this.userData.Gender,
                                };
                                if (this.userData.Status === '4') {
                                    this.renderer.addClass(document.body, 'suspInfoOpened');
                                }
                                const loggedInUser = data.message;
                                loggedInUser.sessionId = userDataJson.sessionId;
                                loggedInUser.memberId = userDataJson.MemberID;
                                localStorage.removeItem('update_data');
                                this.subscriptionsService.emitChangeCurrency(data.message.Currency);
                            }
                        }
                    );
            } else {
                localStorage.removeItem('playerDetails');
            }
        });

        this.loggedIn = false;
        this.showRecall = false;
        const userFromStorage = localStorage.getItem('playerDetails');
        if (userFromStorage) {
            this.userData = JSON.parse(userFromStorage);
            this.userBalance = +this.userData.RealBalance + +this.userData.BonusBalance;
            this.userDataNameWithGender = {
                FirstName: this.userData.FirstName,
                LastName: this.userData.LastName,
                Gender: this.userData.Gender,
            };
            this.loggedIn = true;
        }
        this.loginForm = fb.group({
            'email': [null, Validators.compose([Validators.required, Validators.pattern('[^ @]*@[^ @]*(\.)[A-Za-z]')])],
            'password': [null, Validators.compose([Validators.required, Validators.minLength(7)])],
            'validate': ''
        });
        this.recallForm = fb.group({
            'cvv': [null, Validators.required],
        });


        this.gameEntriesStatus = this.subscriptionsService.getGameFromMyEntries().subscribe(d => {
            const userDataString = localStorage.getItem('playerDetails');
            const userDataJson = JSON.parse(userDataString);
            if (d.type === 'package') {
                this.isLoadingButton = d.index;
            }
            if (d.type === 'ticket') {
                this.isLoadingButtonSub = d.index;
            }
            this.language = localStorage.getItem('pageLanguage');
            this.openedGame = d.id;
            this.packageId = d.index;
            if (d.packageId) {
                this.packageIdTmp = d.packageId;
            } else {
                this.packageIdTmp = d.index;
            }
            this.ticketAmount = d.tickets;
            if (d.tickets > 0) {

                const data = 'sessionId=' + userDataJson.sessionId + '&gameId=' + d.id + '&language=' + this.language + '&isMobile=' + this.lotteryService.isMobile;
                this.lotteryService.postData(globals.appDomain + '/scratchCards/startGameSession/startGameSession_1.json', data).subscribe(
                    result => {
                        window.location.hash = '';
                        if (!result.message.ErrorID) {
                            this.renderer.addClass(document.body, 'modal-open-game');
                            if (this.lotteryService.isMobile) {
                                this.gameURL = result.message.EmbedUrl;
                                this.frameWidth = window.innerWidth;
                                this.frameHeight = 860;
                                this.subscriptionsService.emitToggleContent(false);
                            } else if (window.innerWidth < 1050) {
                                this.gameURL = result.message.EmbedUrl;
                                this.frameWidth = window.innerWidth - (window.innerWidth / 10);
                                this.frameHeight = 540;
                            } else {
                                this.gameURL = result.message.EmbedUrl;
                                this.frameWidth = 960;
                                this.frameHeight = 540;
                            }
                            setTimeout(() => {
                                this.showIframe = 'showIframe';
                            }, 1500);
                            this.ifGameError = false;
                            this.showGameModal = true;
                            this.isLoadingButton = null;
                            this.isLoadingButtonSub = null;
                        } else {
                            this.ifGameError = true;
                            if (result.message.ErrorID === '102') {
                                this.error000 = false;
                                this.error69 = false;
                                this.error102 = true;
                                this.subscriptionsService.checkIfLoadingButton(null);
                            } else if (result.message.ErrorID === '069') {
                                this.error000 = false;
                                this.error102 = false;
                                this.error69 = true;
                                this.subscriptionsService.checkIfLoadingButton(null);
                                this.closeScratchError(true);
                                if (this.router.url.includes('/dashboard')) {
                                    localStorage.setItem('dashboardStatus', 'verification');
                                    this.subscriptionsService.emitAddFunds(true);
                                } else {
                                    localStorage.setItem('dashboardStatus', 'verification');
                                    this.router.navigate(['/' + this.language, 'dashboard']);
                                }
                            } else if (result.message.ErrorID !== '102' && result.message.ErrorID !== '069') {
                                this.error000 = true;
                                this.error69 = false;
                                this.error102 = false;
                                this.subscriptionsService.checkIfLoadingButton(null);
                            }
                        }
                    }
                );
            }
        });

        this.scratchcardCheckoutStatus = this.subscriptionsService.getScratchcardCheckout().subscribe(d => {
            if (JSON.parse(localStorage.getItem('cart'))) {
                this.subscriptionsService.updateCart(JSON.parse(localStorage.getItem('cart')).length + 1);
            } else {
                this.subscriptionsService.updateCart(1);
            }
            const userDataString = localStorage.getItem('playerDetails');
            if (userDataString) {
                this.runCheckout = d.runCheckout;
                this.checkoutId = d.id;
                if (d.amountArray && d.amountArray[d.tickets]) {
                    this.amountArray = d.amountArray;
                    this.checkoutTickets = d.amountArray[d.tickets];
                } else {
                    this.checkoutTickets = d.tickets;
                }
                this.myScratch = d.myScratch;
                this.scrCheckCnt++;
            } else {
                this.subscriptionsService.emitRegisterOrLogin(true);
            }

        });

        this.gameStatus = this.subscriptionsService.getCloseGameStatus().subscribe(data => {
            if (data) {
                this.nowCloseGame();
            }
        });

        this.startInstant = this.subscriptionsService.getStartInstant().subscribe(data => {
            if (data) {
                if (data !== 'off') {
                    this.hideMenu = true;
                } else {
                    this.hideMenu = false;
                }
            }
        });

        this.subscriptionsService.getChangePassword().subscribe(data => {
            if (data) {
                this.resetPassword = !this.resetPassword;
                this.modalSize = 'modal-md';
            }
        });

        this.nameMagicSubscription = this.subscriptionsService.getNameMagic().subscribe(() => {
            setTimeout(() => {
                this.nameSurnameMagic();
            }, 0);
        });

        this.loggedInSubscription = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
            this.loggedIn = data;
        });

        this.resetTokenSubscription = this.subscriptionsService.getResetToken().subscribe(data => {
            this.resetToken = data;
        });

        this.resetEmailSubscription = this.subscriptionsService.getResetEmail().subscribe(data => {
            this.resetEmail = data;
        });

        this.resetPasswordSubscription = this.subscriptionsService.getResetPassword().subscribe(data => {
            this.resetPassword = data;
        });

        this.showForgetPasswordSubscription = this.subscriptionsService.getShowForgetPassword().subscribe(data => {
            this.showForgetPassword = data;
        });

        this.modalSizeSubscription = this.subscriptionsService.getModalSize().subscribe(data => {
            this.modalSize = data;
        });

        this.userBalanceSubscription = this.subscriptionsService.getBalance().subscribe(balance => {
            this.userBalance = balance;
        });

        this.userDataNameWithGenderSubscription = this.subscriptionsService.getUserDataNameWithGender().subscribe(data => {
            this.userDataNameWithGender = data;
        });

        this.jsontranslate.loadTranslations('generalTranslation', this.translate.currentLang);

        this.getPaymentMethodsSub = this.subscriptionsService.getPaymentMethods().subscribe(gpm => {
            this.gpmData = gpm;
        });

        this.getpmService.getPaymentMethods();

    }

    ngOnInit() {
        this.getData();
        this.virtualLogin = '';
        const user = JSON.parse(localStorage.getItem('playerDetails'));
        if (user && user.RealBalance && user.BonusBalance) {
            this.userBalance = +user.RealBalance + +user.BonusBalance;
            const url = this.router.url.replace('/' + this.language + '/', '');
            if (this.userBalance === '0.00' && (url === 'games' || url === 'spielen')) {
                setTimeout(() => {
                    this.tbpulse = 'pulse';
                }, 5000);
                setTimeout(() => {
                    this.tbpulse = '';
                }, 6250);
            }
        }
        this.virtualLogin = '';
        this.toggleContent = true;
        this.startListen();
        this.checkIfListened = false;
        this.gameCloseTriggered = false;
        this.activatedRoute.params
            .subscribe(params => {
                this.languageParams = +params['lang'];
            });

        setTimeout(() => {
            if (this.router.url.indexOf('/en') > -1 || this.router.url.indexOf('/de') > -1) {
                if (this.router.url.indexOf('/en') > -1) {
                    this.translate.use('en');
                    this.language = 'en';
                    localStorage.setItem('pageLanguage', 'en');

                } else if (this.router.url.indexOf('/de') > -1) {
                    this.translate.use('de');
                    this.language = 'de';
                    localStorage.setItem('pageLanguage', 'de');
                }
            }
        }, 500);

        this.isLoadingButton = false;
        this.maxLengthEmail = '80';
        this.activatedRoute.queryParams.subscribe(params => {
            const data = params;
            if (data.bTag) {
                localStorage.setItem('bTag', data.bTag);
            }
        });
        this.title = 'Mr';
        this.showRegister = false;
        this.countrySelect = countries;
        this.userTitle = ['Mr', 'Mrs', 'Ms'];
        this.incomingDrawsSubscription = this.subscriptionsService.getIncomingDraws().subscribe(result => {
            this.incomingDraws = result;
        });

        const startYear = 1900;
        const endYear = 1999;
        const years = [];
        const days = [];
        const months = [];
        for (let i = startYear; i <= endYear; i++) {
            years.push(i);
        }
        for (let i = 1; i <= 31; i++) {
            if (i < 10) {
                days.push('0' + i);
            } else {
                days.push(i);
            }
        }
        for (let i = 1; i <= 12; i++) {
            if (i < 10) {
                months.push('0' + i);
            } else {
                months.push(i);
            }
        }
        this.years = years;
        this.months = months;
        this.days = days;
        this.error48 = false;
        this.error1010 = false;
        this.isCart = false;
        this.devMode = globals.devMode;


        /* loggedIn observer: */
        setInterval(() => {
            if (localStorage.getItem('playerDetails') !== undefined && localStorage.getItem('playerDetails') !== null) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        }, 1000);

        this.updateUserBalance();

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.jsontranslate.loadTranslations('generalTranslation', this.translate.currentLang);
            if (this.translate.currentLang === 'en') {
                this.selected_method_show_name = {
                    selectDisplayName: 'English',
                    selectValue: 'en',
                    selectImageClass: 'en'
                };
                this.language = 'en';
                // this.languageSwitcherReadyToShow = true;

            } else if (this.translate.currentLang === 'de') {
                this.selected_method_show_name = {
                    selectDisplayName: 'German',
                    selectValue: 'de',
                    selectImageClass: 'de'
                };
                this.language = 'de';
                // this.languageSwitcherReadyToShow = true;
            }
        });
        this.sortValues = [{
            selectDisplayName: 'English',
            selectValue: 'en',
            selectImageClass: 'en'
        }, {
            selectDisplayName: 'German',
            selectValue: 'de',
            selectImageClass: 'de'
        }];
        this.waitForLanguage();

        if (window.innerWidth >= 1651) {
            this.navStateOryginal = 3;
        } else if (window.innerWidth >= 1200) {
            this.navStateOryginal = 2;
        } else if (window.innerWidth >= 992) {
            this.navStateOryginal = 1;
        }
        setTimeout(() => {
            if (this.loggedIn) {
                this.nameSurnameMagic();
            }
        }, 500);

        this.eventManager.addGlobalEventListener('window', 'resize', () => {
            if (this.loggedIn) {
                this.nameSurnameMagic();
            }
        });

    }

    displayChanger(event) {
    }

    ngAfterViewInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.checkParams(params).then(output => {
                if (output === 'params') {
                    this.actionService.goToAction(params, this.language, this.loggedIn);
                }
            });
        });
    }

    waitForCountry() {
        if (localStorage.getItem('country')) {
            this.sendCountryCodeToLanguageService();
        } else {
            setTimeout(() => {
                this.waitForCountry();
            }, 200);
        }
    }

    nameSurnameMagic() {
        const lastName = document.getElementsByClassName('lastName')[0];
        const firstName = document.getElementsByClassName('firstName')[0];
        const hi = document.getElementsByClassName('nameWithHi')[0];
        if (window.innerWidth >= 992) {
            if (window.innerWidth >= 1651) {
                this.navState = 3;
            } else if (window.innerWidth >= 1200) {
                this.navState = 2;
            } else if (window.innerWidth >= 992) {
                this.navState = 1;
            }
            if (this.navStateOryginal !== this.navState) {
                this.navStateOryginal = this.navState;
                firstName.classList.remove('hide');
                lastName.classList.remove('hide');
                hi.classList.remove('custom');
                this.hiddenLastNameAt = undefined;
                this.hiddenFirstNameAt = undefined;
            }
            if (window.innerWidth - (this.leftSide.nativeElement.offsetWidth + this.rightSide.nativeElement.offsetWidth) <= 150) {
                lastName.classList.add('hide');
                this.hiddenLastNameAt = window.innerWidth;
                if (window.innerWidth - (this.leftSide.nativeElement.offsetWidth + this.rightSide.nativeElement.offsetWidth) <= 145) {
                    firstName.classList.add('hide');
                    hi.classList.add('custom');
                    this.hiddenFirstNameAt = window.innerWidth;
                }
            } else {
                if (this.hiddenFirstNameAt === undefined && this.hiddenLastNameAt === undefined) {
                    if (this.hiddenFirstNameAt < window.innerWidth) {
                        firstName.classList.remove('hide');
                        hi.classList.remove('custom');
                        this.hiddenFirstNameAt = undefined;

                    }
                    if (this.hiddenLastNameAt < window.innerWidth) {
                        lastName.classList.remove('hide');
                        this.hiddenLastNameAt = undefined;
                    }
                }

            }
        }
    }


    waitForLanguage() {
        if (this.languageService.selectedLanguage === 'en') {
            this.selected_method_show_name = {
                selectDisplayName: 'English',
                selectValue: 'en',
                selectImageClass: 'en'
            };
            this.languageSwitcherReadyToShow = true;

        } else if (this.languageService.selectedLanguage === 'de') {
            this.selected_method_show_name = {
                selectDisplayName: 'German',
                selectValue: 'de',
                selectImageClass: 'de'
            };
            this.languageSwitcherReadyToShow = true;
        } else {
            setTimeout(() => {
                this.waitForLanguage();
            }, 250);
        }
    }

    sendCountryCodeToLanguageService() {
        if (localStorage.getItem('playerDetails')) {
            const userDataFromLS = JSON.parse(localStorage.getItem('playerDetails'));
            this.languageService.makeLanguagesGreatAgain('playerData', userDataFromLS.LanguageID);
        } else {
            this.languageService.makeLanguagesGreatAgain('countryOnly', localStorage.getItem('country'));
        }

    }

    switchLanguage(event) {
        if (event && event.selectValue) {
            const language = event.selectValue;
            if (language !== undefined) {
                this.translate.use(language);
                this.language = language;
                localStorage.setItem('pageLanguage', language);
                if (this.router.url.indexOf('/en') > -1 || this.router.url.indexOf('/de') > -1) {
                    if (this.router.url.indexOf('/en') > -1 && this.language !== 'en') {
                        this.router.navigateByUrl(this.router.url.replace('/en', '/de'));
                    } else if (this.router.url.indexOf('/de') > -1 && this.language !== 'de') {
                        this.router.navigateByUrl(this.router.url.replace('/de', '/en'));
                    }
                }
            }
        }
    }

    checkParams(params) {
        return new Promise(resolve => {
            let utm = '';
            for (const key in params) {
                if (key.includes('utm')) {
                    utm += key + '=' + params[key] + '&';
                }
            }
            if (utm.length !== 0) {
                localStorage.setItem('utm', utm);
                this.paramsService.checkForParams(params);
            } else {
                this.paramsService.checkForParams(params);
            }
            this.canGoOn = true;
            setTimeout(() => {
                resolve('params');
            }, 1500);
        });
    }

    logOut(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        this.loggedIn = this.userService.logOut();
        this.paystackSupport.resetAllVariables();
    }


    goToDashboard(val) {
        this.router.navigate(['/' + this.language, 'dashboard']);
        localStorage.setItem('dashboardStatus', val);
    }

    activeRouteParameters(routename: string, routename_two: string): boolean {
        //@todo: Caly czas nawala funkcja
        return this.router.url.indexOf(routename) > -1 || this.router.url.indexOf(routename_two) > -1;
    }

    resetPasswordForm(form: any): void {
        this.isLoadingButton = true;
        this.toSendEmail = form.email;
        const email = 'email=' + form.email;
        this.lotteryService.postData(globals.appDomain + '/user/resetPassword/resetPassword_nav.json', email)
            .subscribe(
                data => {
                    this.isLoadingButton = false;
                    if (data.message.ErrorID !== undefined && data.message.ErrorID === '048') {
                        this.error48 = true;
                    } else if (data.message.ErrorID !== undefined && data.message.ErrorID === '1010') {
                        this.error1010 = true;
                    } else if (data.message.ErrorID !== undefined && data.message.ErrorID === '037') {
                        this.errorVar = '037';
                    } else if (data.message.ErrorID !== undefined && data.message.ErrorID === '034') {
                        this.errorVar = '034';
                    } else if (data.message.ErrorID !== undefined) {
                        this.errorDefault = true;
                    } else {
                        this.error48 = false;
                        this.error1010 = false;
                        this.errorDefault = false;
                        if (data.message.status === 'OK') {
                            this.renderer.removeClass(document.body, 'modal-open');
                            this.successMessage = true;
                            this.showForgetPassword = !this.showForgetPassword;
                            this.showRecall = !this.showRecall;
                            this.subscriptionsService.emitToggleContent(true);
                        }
                    }
                },
                error2 => {
                    this.isLoadingButton = false;
                }
            );
    }

    closeResetModal() {
        this.renderer.removeClass(document.body, 'modal-open');
    }

    setNewPassword(val) {
        const toSendVal = this.lotteryService.toSendNoEmail(val);
        this.lotteryService.postData(
            globals.appDomain + '/user/resetChangePassword/resetChangePassword_nav.json', toSendVal
        ).subscribe(
            response => {
                if (response.message.status === 'OK') {
                    this.resetSuccess = !this.resetSuccess;
                    this.resetPassword = !this.resetPassword;
                    this.renderer.removeClass(document.body, 'modal-open');
                    this.subscriptionsService.emitToggleContent(true);
                    this.loginService
                        .logIn(globals.appDomain + '/user/login/userLogin_nav_2.json', toSendVal)
                        .subscribe(
                            data => {

                                const sendData = {};
                                sendData['sessionId'] = data.message.SessionID;
                                sendData['timeZone'] = this.timeZone;
                                const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
                                if (cookieIncentiveCodeExists) {
                                    sendData['cookieValue'] = this.cookieService.get('incentiveCode');
                                    this.cookieService.delete('incentiveCode');
                                }
                                localStorage.setItem('knownUser', 'true');
                                this.subscriptionsService.emitFreshLogin(true);
                                this.loginService
                                    .postData
                                    (globals.appDomain + '/user/details/' + data.message.MemberID +
                                        '/userDetails_nav_8.json', this.loginService.getFormUrlEncoded(sendData))
                                    .subscribe(
                                        result => {
                                            localStorage.removeItem('playerDetails');
                                            result.message.sessionId = data.message.SessionID;
                                            result.message.memberId = data.message.MemberID;
                                            this.userBalance = +data.message.RealBalance + +data.message.BonusBalance;
                                            this.userDataNameWithGender = {
                                                FirstName: result.message.FirstName,
                                                LastName: result.message.LastName,
                                                Gender: result.message.Gender,
                                            };
                                            this.loggedIn = false;

                                            const language = localStorage.getItem('pageLanguage');
                                            if (language === null) {
                                                this.languageService.setLanguage(result.message.LanguageID);
                                            } else {
                                                if (language === 'de' || language === 'en') {
                                                    this.language = language;
                                                    this.translate.use(language);
                                                } else {
                                                    this.language = 'en';
                                                    this.translate.use(this.language);
                                                    localStorage.setItem('pageLanguage', 'en');
                                                }
                                            }

                                            localStorage.setItem('playerDetails', JSON.stringify(result.message));
                                            this.loggedIn = true;
                                            this.subscriptionsService.emitChangeCurrency(result.message.Currency);
                                            this.getpmService.getPaymentMethods();
                                        }
                                    );
                            }
                        );
                } else {
                    this.errorDefault = true;
                }
            });
    }


    public getLogin(event: Event) {
        this.showLogin = event;
    }

    public setLogin(event: Event) {
        this.loggedIn = event;
    }

    public getRegister(event: Event) {
        this.showRegister = event;
    }

    showRegModal() {
        this.renderer.addClass(document.body, 'modal-open-register');
        this.subscriptionsService.emitToggleContent(false);

    }

    hideRegModal() {
        this.renderer.removeClass(document.body, 'modal-open-register');
        this.subscriptionsService.emitToggleContent(true);

    }

    goToLogin(form) {
        if (this.loginBanned) {
            this.modalSize = 'modal-md';
            this.showRestrictedLoginRegister = true;
        } else {
            form.reset();
            form.markAsUntouched();
            form.markAsPristine();
            localStorage.setItem('isOpenRegister', 'true');
            setTimeout(() => {
                localStorage.removeItem('isOpenRegister');
            }, 50);
            this.subscriptionsService.emitRegister(false);
            this.renderer.addClass(document.body, 'modal-open-login');
            this.subscriptionsService.emitLogin(true);
            this.subscriptionsService.emitToggleContent(false);
            this.renderer.removeClass(document.body, 'modal-open-register');
            this.subscriptionsService.emitToggleContent(false);
        }
    }

    goToRegistration() {
        const cart = localStorage.getItem('cart');
        if (window.location.href.indexOf('/casino') > -1 && cart) {
            this.subscriptionsService.emitFakeCart(true);
        }
        if (this.registerBanned) {
            this.modalSize = 'modal-md';
            this.showRestrictedLoginRegister = true;
        } else {
            localStorage.setItem('isOpenRegister', 'true');
            this.renderer.addClass(document.body, 'modal-open-register');
            setTimeout(() => {
                localStorage.removeItem('isOpenRegister');
            }, 50);
            this.subscriptionsService.emitRegister(true);
            this.subscriptionsService.emitLogin(false);
        }
    }

    closeModal() {
        this.showLogin = !this.showLogin;
        this.renderer.removeClass(document.body, 'modal-open-login');
        this.renderer.removeClass(document.body, 'modal-open');
        this.subscriptionsService.emitToggleContent(true);
    }

    closeModalSuccess() {
        this.renderer.removeClass(document.body, 'modal-open');
        this.subscriptionsService.emitToggleContent(true);
    }

    closeScratchError(event) {
        if (event !== true) {
            event.preventDefault();
        }
        this.ifGameError = !this.ifGameError;
        this.renderer.removeClass(document.body, 'modal-open');
        this.subscriptionsService.emitToggleContent(true);
    }

    toggleContentV(value) {
        this.renderer.removeClass(document.body, 'modal-open');
        this.subscriptionsService.emitToggleContent(value);
    }

    onClickedOutsideMenu(e: Event) {
        if (!this.lotteryService.isMobile) {
            this.wasClicked = false;
        }
        this.subscriptionsService.emitToggleContent(true);
    }

    onClickedOutsideLang(e: Event) {
        if (!this.lotteryService.isMobile) {
            this.langChange = false;
        }
        this.subscriptionsService.emitToggleContent(true);
    }

    triggerDeposit() {
        this.subscriptionsService.emitNewUser(false);
        if (this.userService.userData.Status === '4' && this.router.url.indexOf('dashboard') !== -1) {
            localStorage.setItem('dashboardStatus', 'verification');
            this.subscriptionsService.emitAddFunds(true);
        } else {
            this.user = JSON.parse(localStorage.getItem('playerDetails'));
            this.userService.getUser();
            this.tbpulse = 'pulse';
            this.hideMenu = false;
            setTimeout(() => {
                this.tbpulse = '';
            }, 125);
            this.subscriptionsService.emitToggleContent(false);
            if (this.user.sessionId) {
                this.userService.checkStatus(this.user.Status).then(data => {
                    if (data === 'noRedirect') {
                        const result = this.gpmData || this.getpmService.gpm_tmp;
                        if (!result) {
                            this.getpmService.getPaymentMethods().then(outfill => {
                                if (outfill === 'GPM') {
                                    if (result && result.message && result.message.PaymentOptions && result.message.PaymentOptions.length) {
                                        this.subscriptionsService.forceOpen = true;
                                        this.subscriptionsService.emitUserNeedIncreseBalance(-1);
                                        this.subscriptionsService.emitForceStepTwo(true);
                                    } else if (result && result.message && result.message.PaymentOptions) {
                                        this.runAddPM();
                                    } else {
                                        setTimeout(() => {
                                            this.triggerDeposit();
                                        }, 500);
                                    }
                                }
                            });
                        } else {
                            if (result && result.message && result.message.PaymentOptions && result.message.PaymentOptions.length) {
                                this.subscriptionsService.forceOpen = true;
                                this.subscriptionsService.emitUserNeedIncreseBalance(-1);
                                this.subscriptionsService.emitForceStepTwo(true);
                            } else if (result && result.message && result.message.PaymentOptions) {
                                const paystackFlow = localStorage.getItem('paystackFlow');
                                if (!paystackFlow) {
                                    this.paystackFlow = false;
                                    this.runAddPM();
                                } else {
                                    this.paystackFlow = true;
                                    this.subscriptionsService.emitUserNeedIncreseBalance(-1);
                                    this.subscriptionsService.emitForceStepTwo(true);
                                }
                            } else {
                                setTimeout(() => {
                                    this.triggerDeposit();
                                }, 500);
                            }
                        }
                    }
                });
            }
        }
    }

    runAddPM() {
        this.goToRegistration();
        this.subscriptionsService.onlyPmStep(true);
    }


    nowCloseGame() {
        this.showIframe = 'hideIframe';
        const userDataString = localStorage.getItem('playerDetails');
        const thisUser = JSON.parse(userDataString);
        if (this.gameCloseTriggered === false) {
            this.gameCloseTriggered = true;
            this.subscriptionsService.upodateHandleScratchCarousel({owlRun: false});
            const data = 'sessionId=' + thisUser.sessionId + '&gameId=' + this.openedGame;
            this.lotteryService.postData(globals.appDomain + '/scratchCards/endGameSession/endGameSession_nav.json', data).subscribe(
                result => {
                    this.renderer.removeClass(document.body, 'modal-open-game');
                    if (Object.keys(result.message).length !== 0 && result.message !== Object) {
                        if (result.message[0]) {
                            this.isUser = true;
                            this.subscriptionsService.upodateHandleScratchCarousel({owlRun: true});
                            this.subscriptionsService.closeModalNow(true);
                            this.subscriptionsService.emitNewScratch(result.message);
                            this.gameCloseTriggered = false;
                            this.subscriptionsService.checkIfLoadingButton(null);
                            this.ifGameError = false;
                            this.subscriptionsService.emitRefreshEntries(true);
                            this.subscriptionsService.emitToggleContent(true);
                            this.userService.getUserDetails(thisUser.sessionId, thisUser.memberId, false);
                            window.location.hash = 'game-closed';
                        }
                    } else {
                        this.isUser = true;
                        this.subscriptionsService.upodateHandleScratchCarousel({owlRun: false});
                        this.subscriptionsService.closeModalNow(true);
                        this.gameCloseTriggered = false;
                        this.subscriptionsService.checkIfLoadingButton(null);
                        this.ifGameError = false;
                        this.subscriptionsService.emitRefreshEntries(true);
                        this.subscriptionsService.emitNewScratch(result.message);
                        this.subscriptionsService.emitToggleContent(true);
                        this.userService.getUserDetails(thisUser.sessionId, thisUser.memberId, false);
                    }
                }
            );
        }
    }

    buyThisScratch($event, tickets, id) {
        this.subscriptionsService.updateRunScratchcardCheckout({
            tickets: tickets,
            id: id,
            amountArray: this.amountArray,
            runCheckout: true,
            myScratch: this.myScratch
        });
    }

    startListen() {
        this.renderer.listen('window', 'message', (event) => {
            if (event && event.data && event.data.type !== 'webpackWarnings'
                && event.data.action !== 'FB_LOG'
                && event.data.messageSource !== 'AUGURY_INSPECTED_APPLICATION') {
                if (event && event.data && typeof event.data !== 'string' && typeof event.data !== 'object'
                    && event.data.type !== 'adblocker'
                    && event.data.type !== 'trustnav_extension') {
                    const data = JSON.parse(event.data);
                    if (data.width && this.checkIfListened === false && !this.lotteryService.isMobile) {
                        this.frameWidth = data.width;
                        this.frameHeight = data.height;
                    } else if (data.width && this.lotteryService.isMobile && !this.checkIfListened) {
                        this.frameWidth = window.innerWidth;
                        this.frameHeight = data.height;
                    }
                    if (data.name === 'scratchcard.goToOverview') {
                        this.nowCloseGame();
                        setTimeout(() => {
                            this.gameCloseTriggered = false;
                            this.buyThisScratch(false, this.ticketAmount, this.packageIdTmp);
                        }, 500);
                    }
                }
            }
        });
    }

    updateUserBalance() {
        const userDataString = localStorage.getItem('playerDetails');
        const userDataJson = JSON.parse(userDataString);
        const sendData = {};
        if (userDataJson) {
            sendData['sessionId'] = userDataJson.sessionId;
            sendData['Fields'] = 'RealBalance,BonusBalance,Status';
            const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
            if (cookieIncentiveCodeExists) {
                sendData['cookieValue'] = this.cookieService.get('incentiveCode');
                this.cookieService.delete('incentiveCode');
            }
            if (this.virtualLogin) {
                sendData['virtualLogin'] = this.virtualLogin.split('=')[1];
            }
            this.loginService
                .postData
                (globals.appDomain + '/user/details/' + userDataJson.MemberID +
                    '/userDetails_nav_9.json', this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    data => {
                        if (data && data.message && data.message.RealBalance && data.message.BonusBalance) {
                            this.userBalance = +data.message.RealBalance + +data.message.BonusBalance;
                            this.subscriptionsService.emitChangeCurrency(data.message.Currency);
                            if (this.userData.Status === '4') {
                                this.renderer.addClass(document.body, 'suspInfoOpened');
                            }
                        }
                    }
                );
        }
    }

    onClickedOutside(e) {
        this.userMenuTooltip = false;
    }

    getData() {
        this.checkForIncomingDraws();
        this.lotteryService.getLotteries(globals.appDomain + '/draws/getAllBundlesOffer/getAllBundlesOffer.json')
            .subscribe(
                result => {
                    result.forEach((elem) => {
                        if (elem.lotteryName === 'Powerball') {
                            this.powerballBundle.push(elem);
                        } else if (elem.lotteryName === 'EuroJackpot') {
                            this.eurojackpotBundle.push(elem);
                        } else if (elem.lotteryName === 'Winner') {
                            this.winnersBundle.push(elem);
                        } else if (elem.lotteryName === 'Winaija Lotto') {
                            this.winaijaLottoBundle.push(elem);
                        }
                    });
                }
            );
    }


    checkForIncomingDraws() {
        if (this.incomingDraws.incomingDraws) {
            // this.getRestLotteries(this.incomingDrawsService.incomingDraws);
        } else {
            setTimeout(() => {
                this.checkForIncomingDraws();
            }, 400);
        }
    }

    getIsLoading(name) {
        return name === this.isLoadingButtonName;
    }

    buyPackage(id, url, lotteryName, entries, price, packageId, name) {
        this.isLoadingButtonName = name;
        let memberId = '';
        let sessionId = '';
        if (this.userData !== null && this.userData !== undefined) {
            sessionId = this.userData.sessionId;
            memberId = this.userData.memberId;
        } else {
            sessionId = 'false';
            memberId = 'false';
        }

        const sendData = {};
        sendData['lotteryLink'] = url;
        sendData['lotteryId'] = id;
        sendData['numberOfEntries'] = entries;
        sendData['lotteryName'] = lotteryName;
        sendData['lotteryItemPrice'] = price;
        sendData['drawCount'] = 1;
        sendData['billingPeriod'] = 0;
        sendData['isSubscription'] = 0;
        sendData['packageId'] = packageId;
        sendData['name'] = name;
        sendData['sessionId'] = sessionId;
        sendData['memberId'] = memberId;
        this.lotteryService.postData
        (globals.appDomain + '/cart/makeBundle/cartMakeBundle.html', this.lotteryService.getFormUrlEncoded(sendData)
        )
            .subscribe(
                result => {
                    const addToCartItem = result.message;
                    const currentCart = localStorage.getItem('cart');
                    if (currentCart !== null && currentCart !== undefined) {
                        const jsonCart = JSON.parse(currentCart);
                        jsonCart.push(addToCartItem);
                        localStorage.setItem('cart', JSON.stringify(jsonCart));
                    } else {
                        const cartArray = [];
                        cartArray.push(addToCartItem);
                        localStorage.setItem('cart', JSON.stringify(cartArray));
                    }
                    this.router.navigate(['/' + this.language, 'cart']);
                    setTimeout(() => {
                        this.isLoadingButtonName = '';
                    }, 1000);

                }
            );

    }

    addFounds() {
        this.tbpulse = 'pulse';
        this.hideMenu = false;
        setTimeout(() => {
            this.tbpulse = '';
        }, 125);
        this.openUserNeedIncreseBalance = false;
        localStorage.setItem('dashboardStatus', 'add-funds');
        this.subscriptionsService.emitAddFunds(true);
        const url = this.router.url.replace('/' + this.language + '/', '');
        if (url === 'games' || url === 'spielen') {
            localStorage.setItem('navigateTo', url);
        }
        this.router.navigate(['/' + this.language, 'dashboard']);
    }

    createRange(number) {
        const items: number[] = [];
        for (let i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }

    languageEmit(lang) {
        this.languageService.languageEmit(lang);
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
        if (this.logoutSubscription) {
            this.logoutSubscription.unsubscribe();
        }
        if (this.showLoginSubscription) {
            this.showLoginSubscription.unsubscribe();
        }
        if (this.showLoginSubscription_tmp) {
            this.showLoginSubscription_tmp.unsubscribe();
        }
        if (this.userDataSubscription) {
            this.userDataSubscription.unsubscribe();
        }
        if (this.registerSubscription) {
            this.registerSubscription.unsubscribe();
        }
        if (this.showWinnerConfetti) {
            this.showWinnerConfetti.unsubscribe();
        }
        if (this.userBalanceSubscription) {
            this.userBalanceSubscription.unsubscribe();
        }
        if (this.userDataNameWithGenderSubscription) {
            this.userDataNameWithGenderSubscription.unsubscribe();
        }
        if (this.loggedInSubscription) {
            this.loggedInSubscription.unsubscribe();
        }
        if (this.resetTokenSubscription) {
            this.resetTokenSubscription.unsubscribe();
        }
        if (this.resetEmailSubscription) {
            this.resetEmailSubscription.unsubscribe();
        }
        if (this.resetPasswordSubscription) {
            this.resetPasswordSubscription.unsubscribe();
        }
        if (this.showForgetPasswordSubscription) {
            this.showForgetPasswordSubscription.unsubscribe();
        }
        if (this.modalSizeSubscription) {
            this.modalSizeSubscription.unsubscribe();
        }
        if (this.gameEntriesStatus) {
            this.gameEntriesStatus.unsubscribe();
        }
        if (this.scratchcardCheckoutStatus) {
            this.scratchcardCheckoutStatus.unsubscribe();
        }
        if (this.myScratch) {
            this.myScratch.unsubscribe();
        }
        if (this.gameStatus) {
            this.gameStatus.unsubscribe();
        }
        if (this.startInstant) {
            this.startInstant.unsubscribe();
        }
        if (this.toggleScratchContent) {
            this.toggleScratchContent.unsubscribe();
        }
        if (this.error74Subscription) {
            this.error74Subscription.unsubscribe();
        }
        if (this.errorDefaultSubscription) {
            this.errorDefaultSubscription.unsubscribe();
        }
        if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
        }
        if (this.incomingDrawsSubscription) {
            this.incomingDrawsSubscription.unsubscribe();
        }
        if (this.triggerDepositFromLink) {
            this.triggerDepositFromLink.unsubscribe();
        }
        if (this.showRestrictedSubscription) {
            this.showRestrictedSubscription.unsubscribe();
        }
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
        if (this.getPaymentMethodsSub) {
            this.getPaymentMethodsSub.unsubscribe();
        }

    }

}
